/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.091 3.5303a.75.75 0 0 0-1.0607-1.0606L0 7.5l5.0303 5.0303a.75.75 0 0 0 1.0607-1.0606L2.8713 8.25h12.4394a.75.75 0 0 0 0-1.5H2.8713L6.091 3.5303Zm11.818 16.9394a.75.75 0 0 0 1.0607 1.0606L24 16.5l-5.0303-5.0303a.75.75 0 0 0-1.0607 1.0606l3.2197 3.2197H8.6893a.75.75 0 0 0 0 1.5h12.4394l-3.2197 3.2197Z"
    clipRule="evenodd"
  />,
  'Change'
);
